<template>
  <div class="investments container">
    <div class="row">
      <div class="col-lg-12">
        <Loader v-show="showLoading"/>
        <div v-if="!showLoading" class="container">
          <div class="row">
            <div class="col">
              <h3>{{ $t('payment-schedule-details.paymentScheduleDetails') }}<span v-if="!openNew">{{ $t('payment-schedule-details.ofLoan', { '1': this.$route.params.id }) }}</span></h3>
              <div>
                <b-button class="income-btn" v-if="openNew" target="_blank" :href="'/payment-schedule-details/' + this.$route.params.id" >{{ $t('payment-schedule-details.openInNewWindow') }}</b-button>
              </div>
              <div class="loan-borrower-details" v-if="scheduleDetails" >
                <stepper :steps="steps" @setstep="setStep"/>
                <div v-for="(scheduleDetail) of scheduleDetails" :key="scheduleDetail.id">
                  <div v-if="step === scheduleDetail.id">
                    <b-table class="payment-schedule" hover :items="getScheduleData(scheduleDetail.details)" responsive="sm">
                      <template v-slot:cell(date)="{value}">
                        {{ showDateInDotFormat(value) }}
                      </template>
                      <template v-slot:cell(principal)="{ value }">
                        {{ value | moneyFormatterWithCurrency(scheduleDetail.currency) }}
                      </template>
                      <template v-slot:cell(interest)="{ value }">
                        {{ value | moneyFormatterWithCurrency(scheduleDetail.currency) }}
                      </template>
                      <template v-slot:cell(monthly_fee)="{ value }">
                        {{ value | moneyFormatterWithCurrency(scheduleDetail.currency) }}
                      </template>
                      <template v-slot:cell(total)="{ value }">
                        {{ value | moneyFormatterWithCurrency(scheduleDetail.currency) }}
                      </template>
                      <template v-slot:cell(status)="{ value }">
                        {{ value }}
                      </template>
                      <template v-slot:cell()="data">
                        {{ data.value | moneyFormatterWithCurrency(scheduleDetail.currency) }}
                      </template>
                      <template v-slot:cell(payment_received)="{ value }">
                        <div class="text-center">{{ value ? showDateInDotFormat(value) : '-' }}</div>
                      </template>
                      <template v-slot:cell(details)="{ value }">
                        <div class="text-center"><a :href="value">{{value}}</a></div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
              <b-alert show variant="warning" v-if="!scheduleDetails">{{ $t('payment-schedule-details.notFoundDetails') }}</b-alert>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moneyMixin from '../mixins/money'
import imageMixin from '../mixins/image'
import dateMixin from '../mixins/date'
import Stepper from '../components/Stepper'
import Loader from '../components/Loader'
import loans from '../api/loans'

export default {
  name: 'Payment-schedule-details',
  components: {Loader, Stepper},
  props: ['openNew'],
  mixins: [moneyMixin, imageMixin, dateMixin],
  data()
  {
    return {
      show: false,
      showLoading: true,
      scheduleDetails: null,
      steps: [],
      step: 1
    }
  },
  mounted()
  {
    this.$root.$emit('shownav', false)
    const loanId = this.$route.params.id
    loans.getMoreDetails(loanId)
        .then(response =>
        {
          if (response.scheduleList)
          {
            // console.log('More details for ', loanId, ' :')
            // console.log(response.scheduleList)
            this.steps = []
            this.scheduleDetails = []
            let scheduleTabStep = 0
            response.scheduleList.forEach(function (schedule)
            {
              if (schedule.schedule && schedule.schedule.schedule)
              {
                scheduleTabStep++
                this.scheduleDetails.push(
                    {
                      id: scheduleTabStep,
                      currency: schedule.loan_currency,
                      status: schedule.schedule_status,
                      details: schedule.schedule.schedule
                    }
                )
                this.steps.push({id: scheduleTabStep, title: schedule.schedule_status_text + ' ' + this.showDateInDotFormat(schedule.target_date), active: scheduleTabStep === 1, completed: false})
              }
            }, this)
          }
        })
        .catch(error =>
        {
          console.log(error)
        })
        .finally(() => (this.showLoading = false))
  },
  watch: {
    step: function (number)
    {
      if (!number)
      {
        return
      }
      try
      {
        // Set completed previous steps
        this.steps.filter(s => s.id < number).forEach(function (step)
        {
          step.active = false
        })
        // Set not active/completed next elements
        this.steps.filter(s => s.id > number).forEach(function (step)
        {
          step.active = false
          step.completed = false
        })
        // Set active current selected step
        this.steps.filter(s => s.id === number).shift().active = true
      }
      catch (e)
      {
        console.log('Something went wrong with changing steps', e)
      }
    }
  },
  methods: {
    setStep(number)
    {
      this.step = number
    },
    getScheduleData(scheduleDetail)
    {
      const resultData = []
      const propsSum = []
      if (scheduleDetail && scheduleDetail.length)
      {
        scheduleDetail.forEach(
            function (schedule)
            {
              if (schedule.schedule_components)
              {
                const withoutZeroPrices = []
                let sum = 0
                Object.keys(schedule.schedule_components).forEach(function (key)
                {
                  const value = parseFloat(schedule.schedule_components[key])
                  if (key === 'capital')
                  {
                    key = 'principal'
                  }
                  sum += value
                  propsSum[key] = (propsSum[key] ? propsSum[key] : 0) + value
                  withoutZeroPrices[key] = value
                })
                let scheduleItem = {}
                scheduleItem.date = schedule.date
                scheduleItem = {...scheduleItem, ...withoutZeroPrices}
                scheduleItem.total = parseFloat(sum.toFixed(2))
                scheduleItem.payment_received = null
                scheduleItem.status = 'Unpaid'
                if (schedule.repayment && schedule.repayment.total > 0)
                {
                  scheduleItem.status = (schedule.repayment.repaid ? 'Paid' : 'Unpaid')
                  if (schedule.repayment.payments && schedule.repayment.payments.length)
                  {
                    scheduleItem.payment_received = Math.max.apply(Math, schedule.repayment.payments.map((o) =>
                    {
                      return (new Date(o.date)).getTime()
                    }))
                  }
                }
                resultData.push(scheduleItem)
              }
            }
            , this)
      }

      // Remove 0 schedule elements section
      try
      {
        for (const k in propsSum)
        {
          // eslint-disable-next-line no-prototype-builtins
          if (propsSum.hasOwnProperty(k))
          {
            if (propsSum[k] === 0)
            {
              // console.log('NEED to remove ', k, 'from: ', resultData)
              for (const key in resultData)
              {
                // eslint-disable-next-line no-prototype-builtins
                if (resultData[key].hasOwnProperty(k))
                {
                  delete resultData[key][k]
                }
              }
            }
          }
        }
      }
      catch (e)
      {
        console.error('Error removing 0-value schedule elements ', e)
      }
      return resultData
    }
  },
  beforeDestroy()
  {
    this.$root.$emit('shownav', true)
  }
}
</script>
<style lang="scss" scoped>
$default-font-size: 15px;

h2 {
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 40px;
  color: #000000;
  flex: none;
  order: 0;
  align-self: flex-start;
  margin: 50px 0 25px;
}

h3 {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 30px;
  color: #000000;
  flex: none;
  order: 0;
  align-self: flex-start;
  margin: 0 10px 20px;
}

.payment-schedule {
  font-size: $default-font-size;
}

.small-stepper {
  font-size: $default-font-size;
  font-weight: bold;
  line-height: 20px;
  margin: 20px auto 0 3px;
}
</style>
